export default "__VITE_ASSET__$pY1f4Vd__"